import i18next, { type TFunction } from 'i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import { initReactI18next } from 'react-i18next';
import { key, piqure } from 'piqure';
import LanguageDetector from 'i18next-browser-languagedetector';

const I18N = key<TFunction>('I18N');

const i18nInjection = piqure();

const loadI18n = () =>
  i18next
    .use(
      resourcesToBackend(
        (language: string, namespace: string) => import(`./locales/${namespace}/${language}.json`),
      ),
    )
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      supportedLngs: ['en', 'fr'],
      fallbackLng: 'en',
      ns: ['cleanapi', 'authentication', 'diagnostic', 'loader', 'rule', 'rules-management'],
    });

export const provideI18n = async () => {
  const i18n = await loadI18n();
  i18nInjection.provide(I18N, i18n);
};

export const injectTranslation = () => i18nInjection.inject(I18N);
